import { useState, useContext } from 'react';
import { UserContext } from '../context/UserContext';
import { canCreateInvoice as canCreateFromInfo } from '../components/InvoiceLimitBanner';

/**
 * 發票數量限制狀態（照 CRM useCustomerLimitCache）：從 InvoiceLimitBanner 的 localStorage 快取初始化，按鈕不會先亮再變灰
 */
export const useInvoiceLimitCache = () => {
  const userContext = useContext(UserContext);
  const { user } = userContext!;

  const readCache = () => {
    if (!user?.organizationId) return null;
    try {
      const cached = localStorage.getItem(`invoice-limit-${user.organizationId}`);
      return cached ? JSON.parse(cached) : null;
    } catch {
      return null; // 快取讀取失敗，使用預設值
    }
  };

  // 還能新增發票（等於上限就不行；發票列表的新增按鈕用）
  const [canCreateInvoice, setCanCreateInvoice] = useState<boolean>(() => {
    const info = readCache();
    return info ? canCreateFromInfo(info) : true;
  });

  // InvoiceLimitBanner 刷新觸發器
  const [limitBannerRefreshTrigger, setLimitBannerRefreshTrigger] = useState(0);

  return {
    canCreateInvoice,
    setCanCreateInvoice,
    limitBannerRefreshTrigger,
    setLimitBannerRefreshTrigger,
  };
};
